import { updatePassword } from 'firebase/auth'
import React, { useEffect, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import init from '../../firebase'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik'
import { passwordSchema } from '../schemas';
import { collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { useUserAuth } from '../../context/UserAuthContext'
import dayjs from 'dayjs'
import GenerateHistoryInvoice from './GenerateHistoryInvoice'
import axios from 'axios'
const PaymentHistory = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const { user, token } = useUserAuth()

    const merchant_id = user?.uid;

    const [history, setHistory] = useState([])
    // console.log('history', history);
    const [merchant, setMerchant] = useState([])

    const getTransactionHistory = async () => {
        try {
            const res = await axios.post(`${base_url}/api/v1/transaction/merchant`,{merchant_id}, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
            setHistory(res.data.data)
        }
        catch (error) {
            console.log('Error while fetching transaction history', error)
        }
    }
    
    const getSingleDocumentHandler = async () => {
        try {
            const res = await getDoc(doc(init.db, "merchants", merchant_id));
            setMerchant(res.data());
        } catch (error) {
            console.log(`Error ${error} `)
        }
    }
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
        getTransactionHistory()
    }, [merchant_id])
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
    }
    const [myPdf, setMyPdf] = useState({})
    const pdfHandler = (item) => {
        setMyPdf(item)
        handleShow();
    }
    return (
        <div className="page-wrapper">
            <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h4>Download Pdf</h4>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-0'>
                        <GenerateHistoryInvoice item={myPdf} merchant={merchant} />
                    </Modal.Body>
                </Modal>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-header bg-white'>
                                <p><b>Transaction History</b></p>
                            </div>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className='table table-bordered'>
                                       <thead>
                                       <tr>
                                            <th>S.No.</th>
                                            <th>Trasaction ID</th>
                                            <th>Amount</th>
                                            <th>Invoice</th>
                                            <th>Date</th>
                                        </tr>
                                       </thead>
                                       <tbody>
                                        {
                                            history.map((item, index) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.transaction_id}</td>
                                                        <td>&#8377; {item.amount}</td>
                                                        <td>
                                                        <button className='btn btn-success' onClick={() => pdfHandler(item)}>Invoice</button>
                                                        </td>
                                                        <td>
                                                            {dayjs(item.created_at).format('DD MMM, YYYY')}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentHistory